"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — PERSONALIZED WELLNESS PLAN
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.personalized_wellness_plan = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-wellness-tool">

        <div class="df-health-compass">


            <p class="wellness-intro">

                Answer a few quick questions to explore your current
                wellness priorities.

            </p>


            <div class="wellness-progress">

                <span class="active" data-wellness-progress="1"></span>
                <span data-wellness-progress="2"></span>
                <span data-wellness-progress="3"></span>

            </div>


            <!--==============================================================
            STEP 1
            ===============================================================-->

            <div
            class="df-step active"
            data-wellness-step="1">


                <h3>

                    About You

                </h3>


                <label>

                    Age

                </label>


                <input
                type="number"
                min="1"
                data-wellness-age>


                <label>

                    Life Stage

                </label>


                <select data-wellness-life-stage>

                    <option value="">
                        Select
                    </option>

                    <option value="teen">
                        Teen Years
                    </option>

                    <option value="young">
                        Young Adult
                    </option>

                    <option value="pregnancy">
                        Pregnancy
                    </option>

                    <option value="midlife">
                        Midlife
                    </option>

                    <option value="menopause">
                        Menopause
                    </option>

                </select>


                <label>

                    Activity Level

                </label>


                <select data-wellness-activity>

                    <option value="">
                        Select
                    </option>

                    <option value="sedentary">
                        Sedentary
                    </option>

                    <option value="light">
                        Lightly Active
                    </option>

                    <option value="moderate">
                        Moderately Active
                    </option>

                    <option value="very">
                        Very Active
                    </option>

                </select>


                <div class="wellness-buttons">


                    <button
                    type="button"
                    class="wellness-primary-btn"
                    data-wellness-next="1">

                        Next

                    </button>


                </div>


            </div>


            <!--==============================================================
            STEP 2
            ===============================================================-->

            <div
            class="df-step"
            data-wellness-step="2"
            hidden>


                <h3>

                    What Would You Like to Focus On?

                </h3>


                <div class="df-checklist">


                    <label>

                        <input
                        type="checkbox"
                        value="weight"
                        data-wellness-goal>

                        Weight Management

                    </label>


                    <label>

                        <input
                        type="checkbox"
                        value="metabolic"
                        data-wellness-goal>

                        Blood Sugar Balance

                    </label>


                    <label>

                        <input
                        type="checkbox"
                        value="hormonal"
                        data-wellness-goal>

                        PCOS Support

                    </label>


                    <label>

                        <input
                        type="checkbox"
                        value="sleep"
                        data-wellness-goal>

                        Better Sleep

                    </label>


                    <label>

                        <input
                        type="checkbox"
                        value="energy"
                        data-wellness-goal>

                        Improve Energy

                    </label>


                    <label>

                        <input
                        type="checkbox"
                        value="menopause"
                        data-wellness-goal>

                        Menopause Wellness

                    </label>


                </div>


                <div class="wellness-buttons">


                    <button
                    type="button"
                    class="wellness-secondary-btn"
                    data-wellness-prev="2">

                        Back

                    </button>


                    <button
                    type="button"
                    class="wellness-primary-btn"
                    data-wellness-next="2">

                        Next

                    </button>


                </div>


            </div>


            <!--==============================================================
            STEP 3
            ===============================================================-->

            <div
            class="df-step"
            data-wellness-step="3"
            hidden>


                <h3>

                    What Are You Experiencing?

                </h3>


                <div class="df-checklist">


                    <label>
                        <input type="checkbox" value="fatigue" data-wellness-symptom>
                        Fatigue
                    </label>


                    <label>
                        <input type="checkbox" value="cravings" data-wellness-symptom>
                        Sugar Cravings
                    </label>


                    <label>
                        <input type="checkbox" value="hunger" data-wellness-symptom>
                        Frequent Hunger
                    </label>


                    <label>
                        <input type="checkbox" value="sleepIssue" data-wellness-symptom>
                        Poor Sleep
                    </label>


                    <label>
                        <input type="checkbox" value="periods" data-wellness-symptom>
                        Irregular Periods
                    </label>


                    <label>
                        <input type="checkbox" value="acne" data-wellness-symptom>
                        Acne
                    </label>


                    <label>
                        <input type="checkbox" value="hair" data-wellness-symptom>
                        Hair Thinning
                    </label>


                    <label>
                        <input type="checkbox" value="mood" data-wellness-symptom>
                        Mood Swings
                    </label>


                    <label>
                        <input type="checkbox" value="waist" data-wellness-symptom>
                        Weight Gain Around Waist
                    </label>


                    <label>
                        <input type="checkbox" value="sweats" data-wellness-symptom>
                        Night Sweats
                    </label>


                </div>


                <div class="wellness-buttons">


                    <button
                    type="button"
                    class="wellness-secondary-btn"
                    data-wellness-prev="3">

                        Back

                    </button>


                    <button
                    type="button"
                    class="wellness-primary-btn"
                    data-wellness-generate>

                        Generate My Wellness Snapshot

                    </button>


                </div>


            </div>


            <!--==============================================================
            RESULT
            ===============================================================-->

            <div
            class="wellness-result"
            data-wellness-result
            hidden>
            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


    let currentStep = 1;


    const steps =

        root.querySelectorAll(

            "[data-wellness-step]"

        );


    const progressItems =

        root.querySelectorAll(

            "[data-wellness-progress]"

        );


    const ageInput =

        root.querySelector(

            "[data-wellness-age]"

        );


    const lifeStageInput =

        root.querySelector(

            "[data-wellness-life-stage]"

        );


    const activityInput =

        root.querySelector(

            "[data-wellness-activity]"

        );


    const resultBox =

        root.querySelector(

            "[data-wellness-result]"

        );


/*==============================================================================*
*SHOW STEP
*==============================================================================*/

    const showStep = (stepNumber)=>{


        currentStep = stepNumber;


        steps.forEach(

            (step)=>{

                const number =

                    parseInt(

                        step.dataset.wellnessStep,

                        10

                    );


                const active =

                    number === stepNumber;


                step.hidden = !active;


                step.classList.toggle(

                    "active",

                    active

                );

            }

        );


        progressItems.forEach(

            (item)=>{

                const number =

                    parseInt(

                        item.dataset.wellnessProgress,

                        10

                    );


                item.classList.toggle(

                    "active",

                    number <= stepNumber

                );

            }

        );

    };


/*==============================================================================*
*NEXT
*==============================================================================*/

    root.querySelectorAll(

        "[data-wellness-next]"

    ).forEach(

        (button)=>{

            button.addEventListener(

                "click",

                ()=>{


                    const step =

                        parseInt(

                            button.dataset.wellnessNext,

                            10

                        );


                    if(step === 1){

                        if(

                            !ageInput.value ||
                            !lifeStageInput.value ||
                            !activityInput.value

                        ){

                            alert(

                                "Please complete all fields before continuing."

                            );

                            return;

                        }

                    }


                    if(step < 3){

                        showStep(

                            step + 1

                        );

                    }

                }

            );

        }

    );


/*==============================================================================*
*PREVIOUS
*==============================================================================*/

    root.querySelectorAll(

        "[data-wellness-prev]"

    ).forEach(

        (button)=>{

            button.addEventListener(

                "click",

                ()=>{

                    const step =

                        parseInt(

                            button.dataset.wellnessPrev,

                            10

                        );


                    if(step > 1){

                        showStep(

                            step - 1

                        );

                    }

                }

            );

        }

    );


/*==============================================================================*
*GENERATE REPORT
*==============================================================================*/

    const generateButton =

        root.querySelector(

            "[data-wellness-generate]"

        );


    if(generateButton){

        generateButton.addEventListener(

            "click",

            ()=>{


                let metabolic = 0;

                let hormonal = 0;

                let sleep = 0;

                let weight = 0;

                let menopause = 0;


                const stage =

                    lifeStageInput.value;


/*==============================================================================*
*LIFE STAGE
*==============================================================================*/

                if(stage === "teen"){

                    hormonal += 1;

                }


                if(stage === "young"){

                    hormonal += 1;

                }


                if(stage === "midlife"){

                    metabolic += 1;

                    menopause += 2;

                }


                if(stage === "menopause"){

                    menopause += 5;

                    sleep += 2;

                }


/*==============================================================================*
*GOALS
*==============================================================================*/

                root.querySelectorAll(

                    "[data-wellness-goal]:checked"

                ).forEach(

                    (goal)=>{


                        if(goal.value === "weight"){

                            weight += 2;

                        }


                        if(goal.value === "metabolic"){

                            metabolic += 2;

                        }


                        if(goal.value === "hormonal"){

                            hormonal += 2;

                        }


                        if(goal.value === "sleep"){

                            sleep += 2;

                        }


                        if(goal.value === "menopause"){

                            menopause += 2;

                        }

                    }

                );


/*==============================================================================*
*SYMPTOMS
*==============================================================================*/

                root.querySelectorAll(

                    "[data-wellness-symptom]:checked"

                ).forEach(

                    (symptom)=>{


                        switch(symptom.value){


                            case "fatigue":

                                metabolic += 2;

                                sleep += 2;

                                break;


                            case "cravings":

                                metabolic += 3;

                                weight += 1;

                                break;


                            case "hunger":

                                metabolic += 3;

                                weight += 1;

                                break;


                            case "sleepIssue":

                                sleep += 4;

                                hormonal += 1;

                                break;


                            case "periods":

                                hormonal += 4;

                                break;


                            case "acne":

                                hormonal += 3;

                                break;


                            case "hair":

                                hormonal += 3;

                                menopause += 1;

                                break;


                            case "mood":

                                hormonal += 2;

                                sleep += 1;

                                menopause += 1;

                                break;


                            case "waist":

                                metabolic += 4;

                                weight += 4;

                                break;


                            case "sweats":

                                menopause += 5;

                                sleep += 2;

                                break;

                        }

                    }

                );


/*==============================================================================*
*SCORES
*==============================================================================*/

                const scores = [


                    {

                        name:"Metabolic Wellness",

                        score:metabolic,

                        tip:"Focus on blood sugar balance, balanced meals, movement, and energy management."

                    },


                    {

                        name:"Hormonal Health",

                        score:hormonal,

                        tip:"Hormonal wellness may deserve attention. Consider exploring menstrual health and PCOS resources."

                    },


                    {

                        name:"Sleep & Recovery",

                        score:sleep,

                        tip:"Improving sleep quality may support your overall wellness and energy levels."

                    },


                    {

                        name:"Weight Management",

                        score:weight,

                        tip:"Small, sustainable lifestyle changes can support healthy weight goals."

                    },


                    {

                        name:"Menopause Wellness",

                        score:menopause,

                        tip:"Menopause-related wellness topics may be relevant based on your responses."

                    }


                ];


                scores.sort(

                    (a,b)=>

                        b.score -

                        a.score

                );


/*==============================================================================*
*RESULT
*==============================================================================*/

                resultBox.innerHTML = `

                    <div class="df-result-card">


                        <h3>

                            Your Personalized Wellness Snapshot

                        </h3>


                        <p>

                            Based on your responses, these appear to be your
                            current priority areas.

                        </p>


                        <div class="df-priority">

                            <strong>

                                1. ${scores[0].name}

                            </strong>

                            <p>

                                ${scores[0].tip}

                            </p>

                        </div>


                        <div class="df-priority">

                            <strong>

                                2. ${scores[1].name}

                            </strong>

                            <p>

                                ${scores[1].tip}

                            </p>

                        </div>


                        <div class="df-priority">

                            <strong>

                                3. ${scores[2].name}

                            </strong>

                            <p>

                                ${scores[2].tip}

                            </p>

                        </div>


                        <h4>

                            Recommended Next Steps

                        </h4>


                        <ul>

                            <li>
                                Maintain regular physical activity.
                            </li>

                            <li>
                                Focus on balanced nutrition.
                            </li>

                            <li>
                                Prioritize quality sleep.
                            </li>

                            <li>
                                Track changes in symptoms over time.
                            </li>

                            <li>
                                Explore relevant Diafemme wellness resources.
                            </li>

                        </ul>


                        <button
                        type="button"
                        class="wellness-reset-btn"
                        data-wellness-reset>

                            Start New Assessment

                        </button>


                        <div class="wellness-disclaimer">

                            <strong>Disclaimer:</strong>

                            This assessment is intended for educational and
                            informational purposes only. It does not provide
                            medical advice, diagnosis, or treatment.

                        </div>


                    </div>

                `;


                steps.forEach(

                    (step)=>{

                        step.hidden = true;

                    }

                );


                resultBox.hidden = false;


                const resetButton =

                    resultBox.querySelector(

                        "[data-wellness-reset]"

                    );


                if(resetButton){

                    resetButton.addEventListener(

                        "click",

                        resetAssessment

                    );

                }


                resultBox.scrollIntoView({

                    behavior:"smooth",

                    block:"nearest"

                });

            }

        );

    }


/*==============================================================================*
*RESET ASSESSMENT
*==============================================================================*/

    function resetAssessment(){


        ageInput.value = "";


        lifeStageInput.selectedIndex = 0;


        activityInput.selectedIndex = 0;


        root.querySelectorAll(

            "[data-wellness-goal]"

        ).forEach(

            (item)=>{

                item.checked = false;

            }

        );


        root.querySelectorAll(

            "[data-wellness-symptom]"

        ).forEach(

            (item)=>{

                item.checked = false;

            }

        );


        resultBox.innerHTML = "";

        resultBox.hidden = true;


        showStep(1);


        root.scrollTo({

            top:0,

            behavior:"smooth"

        });

    }


/*==============================================================================*
*INITIAL STATE
*==============================================================================*/

    showStep(

        currentStep

    );

}

};